<template>
  <footer class="bg-[#039B75] text-white">
    <!-- Links principais -->
    <div class="pt-12 pb-6">
      <div class="max-w-7xl container mx-auto mb-18 grid px-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div v-for="section in footerSections" :key="section.title">
          <h3 class="font-bold text-lg mb-4">{{ section.title }}</h3>
          <a :href="section.link" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <UIcon :name="section.icon" class="w-5 h-5" />
            <span>{{ section.text }}</span>
          </a>
        </div>
      </div>
      <USeparator class="opacity-30" />
      <!-- Slogan e redes sociais -->
      <div
        class="max-w-7xl container mx-auto px-4 mt-6 flex flex-col lg:flex-row items-center justify-center lg:justify-between">
        <div class="w-full lg:w-50 flex justify-center lg:justify-start">
          <AppLogo />
        </div>
        <div class="w-full lg:w-220 mt-10 lg:mt-0 flex justify-center">
          <h2 class="text-2xl text-center lg:text-right">
            O +IFMG significa um IFMG cada vez mais perto de você!
          </h2>
        </div>
        <div class="w-full lg:w-75 mt-10 lg:mt-0 flex items-center justify-center lg:justify-start gap-3">
          <a href="https://ead.ifmg.edu.br"
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:link" class="size-6" />
          </a>
          <a href="https://www.linkedin.com/company/ead-ifmg"
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:linkedin-logo" class="size-6" />
          </a>
          <a href="https://www.instagram.com/ead.ifmg/"
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:instagram-logo" class="size-6" />
          </a>
          <a href="https://youtube.com/maisifmg"
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:youtube-logo" class="size-6" />
          </a>
          <a
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:dots-nine" class="size-3" />
          </a>
          <a
            class="w-10 h-10 bg-white/20 rounded flex items-center justify-center hover:bg-white/30 transition-colors">
            <UIcon name="ph:dots-nine" class="size-3" />
          </a>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="bg-[#01365A] py-6">
      <p class="container max-w-7xl mx-auto px-4 text-center text-sm text-gray-300">
        Copyright © 2020 Instituto Federal de Minas Gerais. Todos os direitos reservados.
      </p>
    </div>
  </footer>
  <AjudaButton />
</template>
<script setup lang="ts">
import type {NavigationMenuItem} from "@nuxt/ui";

const config = useRuntimeConfig()
const baseURL = config.public.baseURL
const basePath = config.public.basePath

const footerSections: NavigationMenuItem[] = [
  {
    title: 'Conheça o IFMG',
    link: 'https://www.ifmg.edu.br/',
    icon: 'ph:buildings',
    text: 'Portal do IFMG'
  },
  {
    title: 'Contato',
    link: 'https://ead.ifmg.edu.br/inicial/contato',
    icon: 'ph:phone',
    text: 'Fale conosco'
  },
  {
    title: 'Sobre',
    link: `${baseURL}${basePath}/aboult`,
    icon: 'ph:info',
    text: 'Saiba mais sobre o +IFMG'
  },
  {
    title: 'EaD do IFMG',
    link: 'https://ead.ifmg.edu.br',
    icon: 'ph:chat-dots',
    text: 'Conecte-se conosco'
  }
]
</script>
